exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card{margin-right:40px;width:160px;height:192px;border-radius:10px;background-color:#fff;box-shadow:0 0 20px 0 rgba(89,159,246,.3);font-family:Fira Sans,sans-serif}.card:focus{outline:none;box-shadow:0 0 20px 0 rgba(89,159,246,.6)}.card img{width:100%;height:95px;-moz-transition:all .5s ease-out;-o-transition:all .5s ease-out;-webkit-transition:all .5s ease-out}.card:hover img{-webkit-transform:scale(1.2);-ms-transform:scale(1.2);transform:scale(1.2)}.img{overflow:hidden;border-top-left-radius:10px;border-top-right-radius:10px}.card h3{font-size:18px;line-height:1.17;margin:10px auto;font-weight:400}.card h3,.card p{text-align:center}.card p{margin-left:10px;margin-right:10px;width:140px;font-size:12px;line-height:1.5;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30c79285","scoped":false,"hasInlineConfig":false}!./src/style/cardsInsurance.css
// module id = 35
// module chunks = 0